export function getChannelCoverUrl(channelData) {
    const { coverUrl, customCoverUrl } = channelData;
    return customCoverUrl || coverUrl;
}
//# sourceMappingURL=cover.js.map